export const logIn_sv = {
  'welcome_header' : 'Gå med i Walking Talking!',
  'welcome_message' : 'En plattform för att hitta andra att promenera med, dela kunskap, erfarenheter och nätverka – med stöd för effektiva promenadmöten.',
  'join' : 'Gå med',
  'create_account' : 'Skapa konto',
  'welcome' : 'Välkommen!',
  'create_account_info' : 'Innan du startar behöver vi lite information från dig.',
  'firstname' : 'Förnamn',
  'lastname' : 'Efternamn',
  'next_step' : 'Nästa steg',
  'create_account_GDPR' : 'Genom att skapa ett Walking Talking-konto accepterar du våra ',
  'user_agreement' : 'Användarvillkor',
  'have_account' : 'Har du redan ett konto?',
  'have_no_account' : 'Har du inget konto?',
  'register_account' : 'Registrera dig',
  'create_account_error_all' : 'Fyll i alla fält för att gå vidare.',
  'create_account_error_email' : 'E-mail adressen används redan. Använd en annan adress eller',
  'upload_profile_picture' : 'Ladda upp en bild',
  'almost_ready' : 'Du är nästan redo att börja promenera!',
  'image_info_header' : 'Profilbild',
  'image_info_message' : 'Ladda upp en profilbild för att skapa och boka promenader.',
  'tip' : 'Tips!',
  'image_info_tips' : 'Användare med profilbild får fler promenader bokade, ladda upp en nu!',

  'log_in_info' : 'Logga in för att skapa eller boka promenader.',
  'log_in_error_incorrect' : 'Kontrollera din information. Du måste fylla i rätt epostadress och lösenord för att fortsätta.',
  'log_in_error_email' : 'Vi hittade inte epostadressen - försök igen. Har du glömt epostadressen du använde, kontakta Walking Talking på kontakt@walkingtalking.com',
  'log_in_error_password' : 'Du verkar ha skrivit fel lösenord. Prova igen eller skapa ett nytt.',
  'forgotten_password' : 'Glömt lösenordet?',

  'send_new_password' : 'Skicka mail om lösenordsbyte',
  'new_password_confirmation_part1' : 'Skickade mail till',
  'new_password_confirmation_part2' : 'Följ instruktionerna i mailet och kom tillbaka hit sedan.',

  'verify_account' : 'Verifiera konto',
  'verify_account_header' : 'För att fortsätta skapa och boka promenader behöver du verifiera ditt konto.',
  'verify_account_step1' : 'Klicka på länken du fick i mailet vi skickade.',
  'verify_account_step2' : 'Klicka sedan på knappen nedan',
  'verified_confirmation' : 'Jag har verifierat epost-adressen',
  'verified_help' : 'Om du inte hittade mailet kan du be om ett nytt verifieringsmail nedan.',
  'send_new_verify' : 'Skicka nytt verifieringsmail',

  'new_verified_header' : 'Skickade verifieringsmail till:',
  'verified_followed' : 'När du har följt instruktionerna i mailet klickar du på Klar nedan.',
  'verified_issues_help' : 'Om det är fel e-postadress, eller om mailet inte kommer fram - kontakta Walking Talking på kontakt@walkingtalking.com',

  'need_email_reset' : 'Vi behöver din epostadress. Fyll i den ovan.',

  'login_error_valid_email' : 'Fyll i en giltig epostadress!',
  'login_error_correct_email' : 'Fyll i rätt epost address och lösenord!',
  'needed_to_create' : 'För att skapa kontot behöver du fylla i alla uppgifter: en profilbild, ',
  'needed_fields' : 'för- och efternamn, epostadress och lösenord'
}